var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show",
        },
      ],
      attrs: { id: "sealList" },
    },
    [
      _c("div", {
        staticClass: "seal-modal",
        on: {
          mousewheel: function ($event) {
            $event.preventDefault()
          },
          click: function ($event) {
            if ($event.target !== $event.currentTarget) {
              return null
            }
            return _vm.closeList.apply(null, arguments)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sealDialog" },
        [
          _c("div", { staticClass: "top" }, [
            _c("span", { staticClass: "title" }, [_vm._v("添加印章")]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "closeIcon", on: { click: _vm.closeList } },
              [_vm._v("x")]
            ),
          ]),
          _vm._v(" "),
          _vm.flash
            ? _c("div", { staticClass: "body" }, [
                _vm.esignature || _vm.elecseal
                  ? _c("div", { staticClass: "eseal-content" }, [
                      _c(
                        "div",
                        {
                          staticClass: "leftBody",
                          staticStyle: { cursor: "default" },
                        },
                        [
                          _vm.esignature
                            ? _vm._l(_vm.tabList, function (item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index * 322 + 5555,
                                    staticClass: "tab",
                                    class: item.isChoosed ? "isChoosed" : "",
                                    style: item.type
                                      ? { color: "#333333" }
                                      : { cursor: "pointer" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.clickTab(item, index)
                                      },
                                    },
                                  },
                                  [
                                    item.type
                                      ? _c("div", {
                                          staticClass: "img",
                                          class:
                                            item.index === -1 ? "bg1" : "bg2",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        style: item.type
                                          ? { fontWeight: "bold" }
                                          : "",
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(item.title) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.elecseal
                            ? _vm._l(
                                _vm.companyNameList,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index * 9999 + 233,
                                      staticClass: "tab",
                                      class: item.isChoosed ? "isChoosed" : "",
                                      style: !item.type
                                        ? { color: "#333333" }
                                        : { cursor: "pointer" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.clickTabOfcomp(item, index)
                                        },
                                      },
                                    },
                                    [
                                      !item.type
                                        ? _c("div", { staticClass: "img" })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          style: !item.type
                                            ? { fontWeight: "bold" }
                                            : "",
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                item.departmentName ||
                                                  item.title
                                              ) +
                                              "\n            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { ref: "rightBody", staticClass: "rightBody" },
                        [
                          _vm._l(_vm.personalSealList, function (item, index) {
                            return _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.tabIndex === 0 && item.downloadUrl,
                                    expression:
                                      "tabIndex === 0 && item.downloadUrl",
                                  },
                                ],
                                key: index * 124 + 3213,
                                staticClass: "sealItem",
                                class: item.isChoosed ? "isChoosed" : "",
                                style:
                                  _vm.personalSealList.length <= 8
                                    ? { width: "145px" }
                                    : "",
                              },
                              [
                                _c("img", {
                                  staticClass: "sealImg",
                                  attrs: { src: item.downloadUrl, alt: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.choosePersonSeal(item, index)
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "sealName" }, [
                                  _vm._v(_vm._s(item.sealName)),
                                ]),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.sealList, function (item, index) {
                            return _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.tabIndex == 10 && item.downloadUrl,
                                    expression:
                                      "tabIndex == 10 && item.downloadUrl",
                                  },
                                ],
                                key: index * 132,
                                staticClass: "sealItem",
                                class: item.isChoosed ? "isChoosed" : "",
                                style:
                                  _vm.sealList.length <= 8
                                    ? { width: "145px" }
                                    : "",
                              },
                              [
                                _c("img", {
                                  staticClass: "sealImg",
                                  attrs: { src: item.downloadUrl, alt: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.chooseComSeal(item, index)
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "sealName" }, [
                                  _vm._v(_vm._s(item.name)),
                                ]),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.tabIndex === 1,
                                  expression: "tabIndex === 1",
                                },
                              ],
                              staticClass: "handSealBody",
                            },
                            [
                              _c("p", { staticClass: "title" }, [
                                _vm._v("请打开手机扫一扫，绘制手绘印章"),
                              ]),
                              _vm._v(" "),
                              _c("div", {
                                ref: "qrCodeUrl",
                                attrs: { id: "qrcode" },
                              }),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "\n              若二维码失效或异常，请\n              "
                                ),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#0975e0",
                                      cursor: "pointer",
                                    },
                                    on: { click: _vm.creatQrCode },
                                  },
                                  [
                                    _vm._v(
                                      "\n                刷新\n              "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.handWrite !== ""
                                ? _c("div", { staticClass: "handSealModal" }, [
                                    _c("div", { staticClass: "modalBg" }),
                                    _vm._v(" "),
                                    _vm._m(0),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ],
                        2
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "bottom" }, [
            _c("div", { staticClass: "buttonRoom" }, [
              _c(
                "button",
                { staticClass: "cancel", on: { click: _vm.closeList } },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "confirm", on: { click: _vm.confirm } },
                [_vm._v("确定")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "toast" } }, [
            _vm.toastShow
              ? _c("div", { staticClass: "confirmToast" }, [
                  _vm._v("\n        请先选择印章\n      "),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modalContent" }, [
      _c("div", { staticClass: "img" }),
      _vm._v(" "),
      _c("p", [_vm._v("绘制成功")]),
      _vm._v(" "),
      _c("p", [_vm._v("请点击确定完成手绘")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }